import React from 'react';
import PropTypes from 'prop-types';

import StyledError from '../styles/Error';

const Error = ({ error }) => {
  return (
    <StyledError>
      <p>
        <span role='img' aria-label='error'>🙁</span> {error}
      </p>
    </StyledError>
  );
};

Error.propTypes = {
  error: PropTypes.string.isRequired,
}

export default Error;
